export enum RegistrationHistoryTabName {
    Pending = 'Pending',
    Processing = 'Processing',
    Completed = 'Completed',
    NeedsAttention = 'Needs Attention',
}
